<style lang="scss" scoped="scoped">
	p {
		color: #303133;
	}
</style>

<template>
	<div ref="container"
		style="overflow: auto;height: 100%;position: relative;padding: 20px;display: flex;flex-direction: column;justify-content: space-between;">
		<div ref="titleBar" class="titleBar" style="flex-shrink: 0;">
			<p style="font-size: 16px;font-weight: 700;">
				{{$t('shebeiyunxing')}}<span style="color: #909399;font-size: 12px;margin-left: 10px;">{{$t('1')}}</span><span
					style="color: #909399;font-size: 12px;">{{$t('fenzhongqiangengxin')}}</span>
			</p>
		</div>
		<div style="flex: 1;display: flex;flex-direction: column;justify-content: space-between;margin-top: 14px;">
			<div style="flex: 5;display: flex;justify-content: space-between">
				<div style="flex: 1;display: flex;border: 1px solid #EBEEF5;border-left: none;align-items: center;">
					<div style="width: 4px;height: 100%;background-color: #67C23A;">

					</div>
					<div style="margin-left: 14px;">
						<p style="font-size: 14px;">
							{{$t('yunxingshebei')}}
						</p>
						<p style="font-size: 20px;">
							{{status.run}}
						</p>
					</div>
				</div>
				<div style="flex: 1;display: flex;border: 1px solid #EBEEF5;border-left: none;margin-left: 20px;align-items: center;">
					<div style="width: 4px;height: 100%;background-color: #E6A23C;">

					</div>
					<div style="margin-left: 14px;">
						<p style="font-size: 14px;">
							{{$t('kongxianshebei')}}
						</p>
						<p style="font-size: 20px;">
							{{status.idle}}
						</p>
					</div>
				</div>
			</div>

			<div style="flex: 5;display: flex;justify-content: space-between;margin-top: 20px;">
				<div style="flex: 1;display: flex;border: 1px solid #EBEEF5;border-left: none;align-items: center;">
					<div style="width: 4px;height: 100%;background-color: #F56C6C;">

					</div>
					<div style="margin-left: 14px;">
						<p style="font-size: 14px;">
							{{$t('guzhangshebei')}}
						</p>
						<p style="font-size: 20px;">
							{{status.fault}}
						</p>
					</div>
				</div>
				<div style="flex: 1;display: flex;border: 1px solid #EBEEF5;border-left: none;margin-left: 20px;align-items: center;">
					<div style="width: 4px;height: 100%;background-color: #909399;">

					</div>
					<div style="margin-left: 14px;">
						<p style="font-size: 14px;">
							{{$t('lixianshebei')}}
						</p>
						<p style="font-size: 20px;">
							{{status.offline}}
						</p>
					</div>
				</div>
			</div>

		</div>



	</div>

</template>
<script type="text/javascript">
	export default {
		name: 'web_home_status',
		components: {

		},

		data() {
			return {
				status:{},
				timmer: null,
			};
		},
		created() {
			// this.timmer = setInterval(() => {
			// 	 this.getEquipmentStateSum()
			// }, 120000)
			 this.getEquipmentStateSum()
		},
		mounted() {
			this.resize()
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();
			});
		},
		watch: {
			'$attrs.orgId'(newValue, oldValue) {
				if (this.utils.isEqual(newValue, oldValue)) {
					return
				}
				this.getEquipmentStateSum()
			},
			
		},
		destroyed() {
			clearInterval(this.timmer)
		},
		methods: {
			async getEquipmentStateSum() {
				let response = await this.http.get('/web/equipment/home/getEquipmentStateSum',{params:{orgId: this.$attrs.orgId}})
				this.status = response.data

			},
			resize() {
				//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
				// setTimeout(() => {
				// 	this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight -
				// 		20 - 20
				// }, 800)



			},

		}
	};
</script>
